import LiveChat from './live-chat'

export default LiveChat
